import axios from 'axios';
import { isPublicResumePathname } from '../utils/routeAccess';

const baseURL = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

const apiClient = axios.create({ baseURL });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('uplift_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('uplift_access_token');
      const p = window.location.pathname;
      if (isPublicResumePathname(p)) {
        return Promise.reject(err);
      }
      if (!p.startsWith('/login') && !p.startsWith('/register')) {
        window.location.assign('/resume/contractor');
      }
    }
    return Promise.reject(err);
  }
);

export default apiClient;
